module.exports = __webpack_public_path__ + "img/twitter.4f61e37d.svg";